module.exports = __webpack_public_path__ + "img/accordion-icon.20f772fc.svg";